/**
 * Flutter channel names for communication between web and Flutter.
 * These channels are registered on the Flutter side and used for web to flutter communication.
 */
export const enum FlutterChannel {
  // Ad-related channels
  SHOW_BANNER_AD = "FlutterShowBannerAd",
  HIDE_BANNER_AD = "FlutterHideBannerAd",

  // Sharing and file operations
  SHARE = "FlutterShare",
  CLIPBOARD = "FlutterClipboard",
  SAVE_FILE = "FlutterSaveFile",

  // Notifications
  FCM = "FlutterFcm",

  // Authentication
  LOGOUT_AUTH = "FlutterLogoutAuthInstance",
  GOOGLE_ID = "FlutterGoogleId",
  APPLE_ID = "FlutterAppleId",

  // In app review
  REQUEST_APP_REVIEW = "FlutterRequestAppReview",
  OPEN_STORE_LISTING = "FlutterOpenStoreListing",

  // Native app check
  REQUEST_NATIVE_APP_CHECK_TOKEN = "FlutterRequestNativeAppCheckToken",

  // Camera & Shorts
  CAMERA = "FlutterCamera",

  // Language
  SET_LANGUAGE = "FlutterSetLanguage",
}
